import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/notice.png';
const _withScopeId = n => (_pushScopeId("data-v-33a17ded"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-main-notive flex-between"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-notive-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
import { onBeforeMount } from "vue";


import { ref } from 'vue';
import { useRouter } from 'vue-router';
// let props = defineProps({
//     notiveInfo:{
//         type:String,
//         default:''
//     }
// })

export default {
  __name: 'notive',
  setup(__props) {
    let notiveInfo = ref('');
    onBeforeMount(() => {
      notiveInfo.value = localStorage.getItem('notice');
    });
    const route = useRouter();
    let notiveDesc = () => {
      route.push({
        path: `/notice`
      });
    };
    return (_ctx, _cache) => {
      const _component_van_notice_bar = _resolveComponent("van-notice-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        class: "tk-notive-content",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(notiveDesc) && _unref(notiveDesc)(...args))
      }, [_createVNode(_component_van_notice_bar, {
        scrollable: "",
        text: _unref(notiveInfo)
      }, null, 8, ["text"])])]);
    };
  }
};